import { TextField } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const SearchBar = (
  {
    searchValue = '',
    handleSearch,
    label = "Index Search"
  },
  ref
) => {
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    setSearchText(searchValue)
  }, [searchValue])

  const onSubmit = (event) => {
    event.preventDefault()
    handleSearch(searchText)
  }
  useImperativeHandle(ref, () => ({
    setSearchValue(value) {
      setSearchText(value)
    }
  }));

  return (
    <form
      autoComplete="off"
      noValidate
      role="search"
      onSubmit={onSubmit}
    >
      <div className="input-group">
        <TextField
          placeholder={label}
          id="search-input"
          type="text"
          variant="outlined"
          fullWidth
          hiddenLabel
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
        />
        <button type="submit">Search</button>
      </div>

    </form>
  )

}
export default forwardRef( SearchBar ) 
